export default __webpack_public_path__ + "static/media/Just_4_icon_white.340bd286.svg";